(function ($) {
  Drupal.behaviors.custom_scripts = {
    attach: function (context) {

      let $mobileMenuHamburger = $("#mobile-menu-hamburger-link");
      let $flyout = $(".mobile-flyout");
      const data = localStorage.getItem('reduxStore');

      if ($mobileMenuHamburger.length > 0 && $flyout.length > 0) {
        //open flyout menu when clicked
        $mobileMenuHamburger.click(function (e) {
          e.preventDefault();
          $flyout.addClass("active");
        });

        $("#close-icon-link").click(function (e) {
          e.preventDefault();
          $flyout.removeClass("active");
        });
      } else {

        console.log("Warning: Mobile menu hamburger or flyout were not on this page.");

      }

      // Show the account menu items if the user is logged in.
      if (data && data.length) {
        const json = JSON.parse(data);
        const appStateIndex = parseInt(json[0].appState);
        const appState = json[appStateIndex];
        if (appState && appState.authentication !== null) {
          const accountInfo = json[parseInt(appState.authentication)];
          const firstNameIndex = parseInt(accountInfo.firstname);
          $('#account-actions h3').text(Drupal.t('Hi, ' + json[firstNameIndex] + '!'));
          $('#account-actions ul li:first-of-type a').attr('href', '/account/logout').text(Drupal.t('Sign Out'));
          $('#account-actions ul li:last-of-type').remove();

          $('#account-links').removeClass('hidden');
          //accountLink.attr('href','/account/settings');
          //$layoutContainer.addClass("txrh-logged-in");
        }
      }
    }
  }
})(jQuery);
